import BillProfitLossComponent from "components/Reports/BillProfitLossComponent";
// import "../../../assets/styles/reports/billProfitLoss.scss";

export default function BillProfitLoss() {
    return <BillProfitLossComponent/>;
}
